export enum ImageType {
  PLPHEADERCARD = 'PLPHEADERCARD',
  PRODUCT_INGREDIENT = 'PRODUCT_INGREDIENT',
  PRODUCT_GALLERY_IMAGE = 'PRODUCT_GALLERY_IMAGE',
  PRODUCT_GALLERY_IMAGE_THUMBNAIL = 'PRODUCT_GALLERY_IMAGE_THUMBNAIL',
  PRODUCT_GALLERY_IMAGE_MODAL = 'PRODUCT_GALLERY_IMAGE_MODAL',
  PRODUCT_GALLERY_IMAGE_MODAL_THUMBNAIL = 'PRODUCT_GALLERY_IMAGE_MODAL_THUMBNAIL',
  PLP_SEARCH_CARD = 'PLP_SEARCH_CARD',
  PLP_LISTING_CONTAINER = 'PLP_LISTING_CONTAINER',
  CHECKOUT_CARD = 'CHECKOUT_CARD',
  APOINT_REDEEM_CARD = 'APOINT_REDEEM_CARD',
  CART_CARD = 'CART_CARD',
  HORIZONTAL_CARD = 'HORIZONTAL_CARD',
  SEARCH_RESULT_CARD = 'SEARCH_RESULT_CARD',
  PRODUCT_DETAILS = 'PRODUCT_DETAILS',
}
